module.exports = __webpack_public_path__ + "static/media/slide-3.21900cb6.png";